import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyBYRhQgAzMiQaQWzxIkcdSF7GG4LTzivSM",
    authDomain: "song-download-app-53ca7.firebaseapp.com",
    projectId: "song-download-app-53ca7",
    storageBucket: "song-download-app-53ca7.appspot.com",
    messagingSenderId: "22751023413",
    appId: "1:22751023413:web:c5761dbca5770de3b5bc7c"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig)

export default firebaseApp
